import type { ReactElement } from 'react';

export function Footer(): ReactElement {
  return (
    <footer className="landing-foot">
      <div className="landing-foot-inner">
        <div className="landing-foot-brand">
          <a href="#" className="landing-logo">
            <svg className="landing-logo-mark" viewBox="0 0 40 40" fill="none">
              <circle cx="20" cy="20" r="18" stroke="currentColor" strokeWidth="1.2" />
              <ellipse cx="20" cy="20" rx="18" ry="6" stroke="currentColor" strokeWidth="1.2" />
              <ellipse cx="20" cy="20" rx="6" ry="18" stroke="currentColor" strokeWidth="1.2" />
              <circle cx="20" cy="20" r="2.5" fill="currentColor" />
            </svg>
            <span className="landing-logo-text">
              gimbal<span className="landing-logo-dot">.cloud</span>
            </span>
          </a>
          <p className="landing-foot-tag">The channel between agents and worlds.</p>
        </div>

        <div className="landing-foot-cols">
          <div className="landing-foot-col">
            <div className="landing-foot-h">PRODUCT</div>
            <a href="#">Spaces</a>
            <a href="#">GimbalPortal</a>
            <a href="#">GimbalProxy Plugin</a>
            <a href="#">MCP Surface</a>
          </div>
          <div className="landing-foot-col">
            <div className="landing-foot-h">DEVELOPERS</div>
            <a href="#">Documentation</a>
            <a href="#">API Reference</a>
            <a href="#">Wire Protocol</a>
            <a href="#">GitHub</a>
          </div>
          <div className="landing-foot-col">
            <div className="landing-foot-h">COMPANY</div>
            <a href="#">Manifesto</a>
            <a href="#">Changelog</a>
            <a href="#">Status</a>
            <a href="#">Contact</a>
          </div>
        </div>
      </div>

      <div className="landing-foot-bar landing-mono">
        <span>© 2026 Gimbal Systems, Inc.</span>
        <span className="landing-foot-region">
          <span className="landing-dot cyan" /> region · us-west-2
          <span className="landing-foot-sep">·</span>
          <span className="landing-dot mag" /> region · eu-central-1
          <span className="landing-foot-sep">·</span>
          <span className="landing-dot" /> region · ap-northeast-1
        </span>
        <span>v2.4.1 · build 4a7b219</span>
      </div>
    </footer>
  );
}
